import { PlaceholdersId, TFComponent } from '@types';
import { PlanCardsPlaceholder } from './planCards';

export const planCards: TFComponent = {
	component: PlanCardsPlaceholder,
	id: PlaceholdersId.planCards,
	name: 'planCards',
};
